import React from "react";
import {StyleSheet, Text, View} from "react-native";
import {useMediaPath} from "@/data/app-data-hooks";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

interface FolderBreadcrumbProps {
    folderId: string;
    orgId: string;
    size?: 'sm' | 'md' | 'lg';
}

export function FolderBreadcrumb({folderId, orgId, size}: FolderBreadcrumbProps) {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme, size || 'md');
    const {data: folderPath} = useMediaPath(orgId, folderId);

    return (
        <View style={styles.breadcrumbContainer}>
            {folderPath.map((folderName, index) => (
                <React.Fragment key={index}>
                    <Text style={styles.breadcrumbText}>{folderName}</Text>
                    {index < folderPath.length - 1 && (
                        <Text style={styles.breadcrumbSeparator}> / </Text>
                    )}
                </React.Fragment>
            ))}
        </View>

    );
}

const createStyles = (theme: ThemeType, size: string) => StyleSheet.create({
    breadcrumbContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    breadcrumbText: {
        fontSize: size === 'sm' ? 12 : size === 'lg' ? 16 : 14,
        color: theme.colors.textSecondary,
    },
    breadcrumbSeparator: {
        fontSize: 14,
        color: theme.colors.textSecondary,
        opacity: 0.6,
    },
});
